<template>
  <div>
    <li>
      <a @click.prevent="show_modal()">
        <i class="fa fa-chart-bar"></i>
        <span v-if="$store.state.show_menu_text">
          <span>&nbsp;</span>
          <span>Indicateurs</span>
        </span>
        <div style="text-align: center;" v-if="stats != null">
          <span style="color: green;">{{stats.positive.to_answer}}</span>
          <span v-if="$store.state.show_menu_text">/</span>
          <br v-else />
          <span style="color: red;">{{stats.negative.to_answer}}</span>
        </div>
        <div v-else>
          <i class="fa fa-spinner fa-spin"></i>
        </div>
      </a>
    </li>
    <div>
      <div class="modal" :class="{'is-active': modal_opened}" v-if="stats != null">
        <div class="modal-background" @click="modal_opened = false"></div>
        <div class="modal-card" style="width: 70%;">
          <header class="modal-card-head">
            <p class="modal-card-title">Mes indicateurs</p>
            <button class="delete" @click="modal_opened = false"></button>
          </header>
          <section class="modal-card-body" v-if="!allloaded">
            <i class="fa fa-spinner fa-spin"></i>
          </section>
          <section class="modal-card-body" v-if="allloaded">
            <div v-for="e in stats.by_establishment" class="content">
              <h4>{{e.name}}</h4>
              <table class="table is-narrow">
                <thead>
                  <tr>
                    <th>Plateforme</th>
                    <th>Reçu</th>
                    <th>+</th>
                    <th>-</th>
                    <th>Répondus</th>
                    <th>+</th>
                    <th>-</th>
                    <th>A rédiger</th>
                    <th>+</th>
                    <th>-</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="p in e.by_platform" v-show="p.total.to_answer > 0 || e.show_all == true">
                    <td>{{p.name}}</td>
                    <td><strong>{{p.total.received}}</strong></td>
                    <td><strong class="green">{{p.positive.received}}</strong></td>
                    <td><strong class="red">{{p.negative.received}}</strong></td>
                    <td><strong>{{p.total.answered}}</strong></td>
                    <td><strong class="green">{{p.positive.answered}}</strong></td>
                    <td><strong class="red">{{p.negative.answered}}</strong></td>
                    <td><strong>{{p.total.to_answer}}</strong></td>
                    <td><strong class="green">{{p.positive.to_answer}}</strong></td>
                    <td><strong class="red">{{p.negative.to_answer}}</strong></td>
                  </tr>
                </tbody>
              </table>
              <button class="button is-primary" @click="e.show_all = !e.show_all">
                <span v-if="e.show_all == false">Tout voir</span>
                <span v-else>Cacher les lignes inutiles</span>
              </button>
              <hr />
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CONSULTANT_STATS_FAST from '@/gql/queries/consultant.graphql'
import CONSULTANT_STATS from '@/gql/queries/consultantStats.graphql'
import { gqlQuery } from '@/gqlClient.js'
import settings from "@/settings.coffee"

export default {
  name: 'ConsultantStatPreview',
  data() {
    return {
      modal_opened: false,
      stats: null,
      my_establishments_uids: {},
      allloaded: false
    };
  },
  methods: {
    async fetch_data_fast() {
      const self = this;
      const response = await gqlQuery(CONSULTANT_STATS_FAST, { uid: self.$store.state.profile.data.uid });
      self.stats = JSON.parse(response.body.data.consultant.stats_fast);
    },
    async fetch_data() {
      this.stats = null;
      const self = this;
      const response = await gqlQuery(CONSULTANT_STATS, { uid: self.$store.state.profile.data.uid });
      const stats = JSON.parse(response.body.data.consultant.stats);
      stats.by_establishment = stats.by_establishment.map(function(item) {
        item.show_all = false;
        return item;
      });
      // garder les uids des établissements
      stats.by_establishment.forEach(function(item) {
        self.my_establishments_uids[item.uid] = item.name;
      });
      self.stats = stats;
    },
    show_modal() {
      const self = this;
      self.modal_opened = true;
      self.fetch_data().then(function() {
        self.allloaded = true;
      });
    }
  },
  mounted() {
    const self = this;
    self.fetch_data_fast();
    // écoute des messages d'état
    self.$djangows['onmodelsignals'](
      { modelName: "review", appLabel: "review" },
      function(event) {
        if (event.obj.establishment in self.my_establishments_uids) {
          self.fetch_data_fast();
        }
      }
    );
  }
}
</script>

<style scoped>
.green {color: green;}
.red {color: red;}
</style>
